import * as React from 'react';
import { ConfigProvider, Empty } from 'antd';
import locales from '@/config/locale';
import emptySvg from '@/assets/images/empty.svg';

import { setTwoToneColor } from '@ant-design/icons';
import moment from 'moment';

type AntdConfigProviderProp = {
  children: React.ReactNode,
  locale: string,
};

function AntdConfigProvider({ children, locale }: AntdConfigProviderProp) {
  React.useEffect(() => {
    ConfigProvider.config({
      prefixCls: 'winitd'
    });
    moment.locale(((locale == 'en-US' ? 'en' : locale) || '').toLowerCase());
    setTwoToneColor('#A57848');
  }, []);
  return (
    <ConfigProvider locale={locales[locale]?.antd}
      // space={{ size: 'small' }}
      prefixCls='winitd'
      // iconPrefixCls='winiticon'
      autoInsertSpaceInButton={false}
      renderEmpty={() => (
        <Empty
          image={<img src={emptySvg} alt="empty" />}
          className="p-lg"
        >
        </Empty>
      )}
    >
      {children}
    </ConfigProvider>
  );
}

export default AntdConfigProvider;
